import * as React from 'react';
import { observer } from 'mobx-react';

import { usePermissionsStore, useUiStore } from 'stores/index';
import SocialNetworks from 'shared/newComponents/SocialNetworks';

import Balance from './Balance';
import ReferralButton from './ReferralButton';

import './Bottom.modules.scss';

const Bottom: React.FC = () => {
  const uiStore = useUiStore();
  const permissionsStore = usePermissionsStore();

  return (
    <div styleName="bottom">
      {uiStore.menuState.opened && (
        <>
          {permissionsStore.canViewBilling && <Balance />}
          <ReferralButton />
          <SocialNetworks />
        </>
      )}
    </div>
  );
};

export default observer(Bottom);
